import api from './metadata.api'
import { createApiAction } from '../../../../Helpers/actions'

import { SAVE_METADATA, SAVE_METADATUM } from './metadata.constants'
import { refreshContact } from '../../MediaPlayer/mediaPlayer.actions'

// params: productName, contactId, parameters
// TODO have backend support multiple metadata submissions in one API call
//export const saveMetadata = createApiAction(SAVE_METADATA, api.saveMetadata)

//Passing in an array for parity with createApiAction actions
export const saveMetadata = ([productName, contactId, goalId, parameters = {}]) => async dispatch => {
  dispatch({ type: SAVE_METADATA.REQUESTED })

  const saveMetadatumParams = Object.values(parameters)

  if (saveMetadatumParams.length < 1) {
    return dispatch({
      response: [],
      type: SAVE_METADATA.SUCCESS,
    })
  }

  try {
    const response = await Promise.all(
      saveMetadatumParams.map(param => api.saveMetadatum(productName, contactId, param.key, param)),
    )

    dispatch({
      response,
      type: SAVE_METADATA.SUCCESS,
    })
    dispatch(refreshContact(contactId, { goalId }))
  } catch (error) {
    dispatch({
      error,
      type: SAVE_METADATA.FAILURE,
    })

    throw error
  }
}

// params: productName, contactId, metadataKey, parameters
export const saveMetadatum = createApiAction(SAVE_METADATUM, api.saveMetadatum)
